import { initComponent } from './core/init-component.js'

initComponent('.js-sort-dropdown', snippet => {
  const trigger = snippet.querySelector('.js-sort-trigger')
  const panel = snippet.querySelector('.js-sort-panel')
  const activeLabel = snippet.querySelector('.js-sort-active-value')

  if (!trigger || !panel) return {}

  function open() {
    panel.classList.remove('hidden')
    trigger.setAttribute('aria-expanded', 'true')
    document.addEventListener('click', onOutsideClick)
    document.addEventListener('keydown', onKeyDown)
  }

  function close() {
    panel.classList.add('hidden')
    trigger.setAttribute('aria-expanded', 'false')
    document.removeEventListener('click', onOutsideClick)
    document.removeEventListener('keydown', onKeyDown)
  }

  function toggle(e) {
    e.stopPropagation()
    const isOpen = trigger.getAttribute('aria-expanded') === 'true'
    isOpen ? close() : open()
  }

  function onOutsideClick(e) {
    if (!snippet.contains(e.target)) close()
  }

  function onKeyDown(e) {
    if (e.key === 'Escape') {
      close()
      trigger.focus()
    }
  }

  async function renderPage(searchParams) {
    const gridContainer = document.getElementById('CollectionProductGrid')
    if (!gridContainer) return
  
    const productGrid = gridContainer.querySelector('.js-product-grid')
    productGrid?.classList.add('loading')
  
    const url = `${window.location.pathname}?${searchParams}`
  
    try {
      const response = await fetch(url)
      const html = await response.text()
      const parsed = new DOMParser().parseFromString(html, 'text/html')
  
      const newGrid = parsed.getElementById('CollectionProductGrid')

      if (newGrid) {
        gridContainer.innerHTML = newGrid.innerHTML
      }
  
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}?${searchParams}`
      )      
    } catch (error) {
      console.error('Sort fetch error:', error)
    } finally {
      productGrid?.classList.remove('loading')
    }
  }

  async function onOptionClick(e) {
    const btn = e.target.closest('.js-sort-option')
    if (!btn || btn.disabled) return
  
    const value = btn.dataset.value
    const label = btn.textContent.trim()
  
    panel.querySelectorAll('.js-sort-option').forEach(el => {      
      el.removeAttribute('aria-current')
    })
      
    btn.setAttribute('aria-current', 'true')
  
    if (activeLabel) {
      activeLabel.textContent = label
    }
  
    close()
  
    const currentParams = new URLSearchParams(window.location.search)
    currentParams.set('sort_by', value)

    trigger.focus({ preventScroll: true })
  
    await renderPage(currentParams.toString())
  }
  
  trigger.addEventListener('click', toggle)
  panel.addEventListener('click', onOptionClick)

  return {
    unload() {
      trigger.removeEventListener('click', toggle)
      panel.removeEventListener('click', onOptionClick)
      document.removeEventListener('click', onOutsideClick)
      document.removeEventListener('keydown', onKeyDown)
    }
  }
})